/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

import { ReactNode } from 'react'

// @mui material components
import Grid from '@mui/material/Grid'

// Material Dashboard 2 PRO React TS components

import brandPrimaryLogo from 'assets/images/mockingbird-logo-primary.png'
import brandPrimaryText from 'assets/images/mockingbird-primary-text.png'
import MDBox from 'components/MDBox'
import PageLayout from 'modules/LayoutContainers/PageLayout'

// Declaring props types for BasicLayout
interface Props {
	children: ReactNode
}

function BasicLayout({ children }: Props): JSX.Element {
	return (
		<PageLayout>
			<MDBox position="absolute" width="100%" minHeight="100vh" />
			<MDBox display={'flex'} flexDirection={'row'} justifyContent={'center'} pt={'10vh'}>
				<MDBox component="img" src={brandPrimaryLogo} alt="Brand" width="4rem" />
				<MDBox component="img" src={brandPrimaryText} alt="Brand" width="16rem" />
			</MDBox>
			<MDBox px={1} width="100%" height="70vh" mx="auto">
				<Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
					<Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
						{children}
					</Grid>
				</Grid>
			</MDBox>
		</PageLayout>
	)
}

export default BasicLayout
